import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
// import { queryClient } from "../../services/queryClient";
import { getToken } from "../../utils/getToken";

type Payload = {
  id: any;
  amount: string;
  reason: string;
};

export const useCreateCreditHistoryMutation = () => {
  const token = getToken();
  return useMutation({
    mutationFn: (payload: Payload) =>
      axiosInstance
        .post(
          "/credits/apply-for-customer",
          { ...payload, amount: +payload?.amount },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      //   queryClient.invalidateQueries({ queryKey: ["useGetCustomerQuery"] });
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
